{
  "hrDerby": {
    "roster": [],
    "countDownDefault": 90,
    "currentBatter": {
      "name": "Current batter",
      "guid": "",
      "batting": true,
      "hrDerby": 0
    },
    "countDown": 90
  },
  "config": {
    "homeColor": "#142c48",
    "boxScoreTime": null,
    "autopilot": null,
    "skipPortraits": null,
    "awayPicker": "#020202",
    "url": "https://stats.baseball.cz/cs/events/2023-extraliga/schedule-and-results/box-score/124733",
    "awaySecondaryPicker": null,
    "awayLogoUrl": "../../../assets/logos/czech/DRA.png",
    "homeSecondaryColor": null,
    "statusMsg": null,
    "awayColor": "#020202",
    "keyColor": null,
    "unites": "MPH",
    "countDownDefault": null,
    "batterTime": null,
    "homePicker": "#142c48",
    "commentator2": null,
    "homeLogoUrl": "../../../assets/logos/czech/TEM.png",
    "skin": "default",
    "syncManualDataMidInning": true,
    "newHrPlayer": null,
    "homeSecondaryPicker": null,
    "awaySecondaryColor": null,
    "manualStatus": null,
    "commentator1": null
  },
  "uid": "0ty4nifv4wjQAFoOwKJA",
  "ownerUid": "SNHWlR0cy7ew2XTdl7xEKSjIaYu1",
  "customTable": {
    "width": 400,
    "teamGuid": null,
    "data": [
      {
        "value": "",
        "label": "HP: Home Plate"
      },
      {
        "label": "1B: First Base",
        "value": ""
      },
      {
        "value": "",
        "label": ""
      },
      {
        "value": "",
        "label": ""
      },
      {
        "label": "",
        "value": ""
      },
      {
        "value": "",
        "label": ""
      },
      {
        "value": "",
        "label": ""
      },
      {
        "value": "",
        "label": ""
      },
      {
        "label": "",
        "value": ""
      },
      {
        "label": "",
        "value": ""
      }
    ],
    "title": "Umpires"
  },
  "url": "https://stats.baseball.cz/cs/events/2023-extraliga/schedule-and-results/box-score/124733",
  "updateLock": "42847457-b102-40a3-b27a-77c583e0792d",
  "game": {
    "started": true,
    "bottom": false,
    "inning": 2,
    "strikes": 0,
    "currentPitcher": {
      "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/b3e02d3d-da55-4244-96ce-d52b2cf767e8.png",
      "gameStats": {
        "batting": {},
        "pitching": {
          "pitches": 26,
          "k": 1,
          "ra": 2,
          "ip": "1.2",
          "strikes": 18,
          "er": 2,
          "h": 3
        }
      },
      "teamGuid": "26249",
      "records": [],
      "guid": "266304",
      "batting": false,
      "position": 1,
      "name": "VANK Ondřej",
      "seasonStats": {
        "pitching": {
          "er": 18,
          "era": 3.796875,
          "bb": 30,
          "ip": 42.2,
          "k": 42
        },
        "batting": {}
      }
    },
    "outs": 2,
    "firstUpdate": {
      "seconds": 1692447910,
      "nanoseconds": 418000000
    },
    "home": {
      "guid": "26249",
      "hits": 1,
      "scoreBoard": [
        1
      ],
      "lineup": [
        {
          "players": [
            {
              "name": "BLAžKA Ondřej",
              "batting": true,
              "teamGuid": "26249",
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              },
              "seasonStats": {
                "batting": {
                  "ab": 127,
                  "obp": 0.39622641509433965,
                  "bb": 25,
                  "pa": 159,
                  "ba": 0.2755905511811024,
                  "h": 35,
                  "hr": 1,
                  "hbp": 3
                },
                "pitching": {}
              },
              "position": 8,
              "records": [
                {
                  "inning": 1,
                  "play": "F8"
                }
              ],
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/357643ba-18ab-40bc-a1cd-5fce7e0725fa.png",
              "guid": "266285"
            }
          ]
        },
        {
          "players": [
            {
              "position": 2,
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "ab": 176,
                  "bb": 22,
                  "pa": 201,
                  "obp": 0.5223880597014925,
                  "h": 81,
                  "hbp": 2,
                  "ba": 0.4602272727272727,
                  "hr": 19
                }
              },
              "teamGuid": "26249",
              "records": [
                {
                  "inning": 1,
                  "play": "H7"
                }
              ],
              "gameStats": {
                "pitching": {},
                "batting": {
                  "ab": 1,
                  "h": 1
                }
              },
              "batting": true,
              "name": "ČERVENKA Martin",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/5be21f2c-3aa7-410e-a348-198530491ea4.png",
              "guid": "266287"
            }
          ]
        },
        {
          "players": [
            {
              "records": [
                {
                  "inning": 1,
                  "play": "Ks"
                }
              ],
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              },
              "batting": true,
              "seasonStats": {
                "batting": {
                  "pa": 185,
                  "obp": 0.40540540540540543,
                  "bb": 25,
                  "ba": 0.30718954248366015,
                  "h": 47,
                  "hr": 3,
                  "hbp": 3,
                  "ab": 153
                },
                "pitching": {}
              },
              "guid": "266300",
              "position": 9,
              "teamGuid": "26249",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/098c758f-98f2-45c7-9f41-d90297820c6a.png",
              "name": "PETIT Keibert"
            }
          ]
        },
        {
          "players": [
            {
              "records": [
                {
                  "play": "FC",
                  "inning": 1
                }
              ],
              "name": "MINAříK Marek",
              "seasonStats": {
                "batting": {
                  "pa": 165,
                  "ba": 0.29333333333333333,
                  "obp": 0.3393939393939394,
                  "hr": 8,
                  "h": 44,
                  "bb": 8,
                  "hbp": 4,
                  "ab": 150
                },
                "pitching": {}
              },
              "teamGuid": "26249",
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              },
              "position": 11,
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/c97903b1-734c-42e9-856b-915174a7f9eb.png",
              "batting": true,
              "guid": "266297"
            }
          ]
        },
        {
          "players": [
            {
              "guid": "266302",
              "batting": true,
              "teamGuid": "26249",
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "ab": 130,
                  "ba": 0.24615384615384617,
                  "obp": 0.33557046979865773,
                  "pa": 149,
                  "h": 32,
                  "hr": 1,
                  "bb": 16,
                  "hbp": 2
                }
              },
              "name": "SMOLA Filip",
              "position": 6,
              "gameStats": {
                "pitching": {},
                "batting": {
                  "ab": 1
                }
              },
              "records": [
                {
                  "inning": 1,
                  "play": "Ks"
                }
              ],
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/ba35a0c6-6c2b-461a-99a5-7d9ba6b4e7fa.png"
            }
          ]
        },
        {
          "players": [
            {
              "gameStats": {
                "batting": {},
                "pitching": {}
              },
              "records": [],
              "seasonStats": {
                "batting": {
                  "pa": 194,
                  "ba": 0.25301204819277107,
                  "hr": 2,
                  "obp": 0.3402061855670103,
                  "bb": 17,
                  "ab": 166,
                  "h": 42,
                  "hbp": 7
                },
                "pitching": {}
              },
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/d950f673-9733-4d7e-851a-6fa8265beaa9.png",
              "batting": true,
              "position": 3,
              "guid": "266306",
              "name": "ZELENKA Michal",
              "teamGuid": "26249"
            }
          ]
        },
        {
          "players": [
            {
              "teamGuid": "26249",
              "batting": true,
              "records": [],
              "position": 4,
              "name": "NEVěřIL David",
              "gameStats": {
                "pitching": {},
                "batting": {}
              },
              "guid": "266299",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/1df9b1d8-bd36-461e-9cc8-33581a46a6ae.png",
              "seasonStats": {
                "batting": {
                  "pa": 141,
                  "hbp": 1,
                  "h": 21,
                  "ba": 0.18421052631578946,
                  "obp": 0.3120567375886525,
                  "ab": 114,
                  "bb": 22,
                  "hr": 0
                },
                "pitching": {}
              }
            }
          ]
        },
        {
          "players": [
            {
              "records": [],
              "name": "HLUCHý Viktor",
              "position": 5,
              "teamGuid": "26249",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/97ea00e9-e271-47cb-8800-62f4c80dae74.png",
              "guid": "266293",
              "seasonStats": {
                "batting": {
                  "hr": 0,
                  "bb": 19,
                  "ba": 0.18627450980392157,
                  "hbp": 2,
                  "pa": 126,
                  "h": 19,
                  "obp": 0.31746031746031744,
                  "ab": 102
                },
                "pitching": {}
              },
              "gameStats": {
                "batting": {},
                "pitching": {}
              },
              "batting": true
            }
          ]
        },
        {
          "players": [
            {
              "gameStats": {
                "pitching": {},
                "batting": {}
              },
              "batting": true,
              "name": "DRáPELA Šimon",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/65fcc40a-4fee-3f15-3cab-2356d1b1e673.png",
              "position": 7,
              "teamGuid": "26249",
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "hbp": 2,
                  "ba": 0.21052631578947367,
                  "hr": 0,
                  "h": 20,
                  "obp": 0.3333333333333333,
                  "pa": 114,
                  "bb": 16,
                  "ab": 95
                }
              },
              "guid": "266289",
              "records": []
            }
          ]
        }
      ],
      "shortName": "TEM",
      "pitchers": [
        {
          "teamGuid": "26249",
          "position": 1,
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/b3e02d3d-da55-4244-96ce-d52b2cf767e8.png",
          "gameStats": {
            "pitching": {
              "strikes": 18,
              "h": 3,
              "k": 1,
              "pitches": 26,
              "ra": 2,
              "ip": "1.2",
              "er": 2
            },
            "batting": {}
          },
          "seasonStats": {
            "batting": {},
            "pitching": {
              "ip": 42.2,
              "era": 3.796875,
              "er": 18,
              "bb": 30,
              "k": 42
            }
          },
          "guid": "266304",
          "records": [],
          "batting": false,
          "name": "VANK Ondřej"
        }
      ],
      "runs": 1,
      "errors": 0,
      "fullName": "TEM",
      "roster": [
        {
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1
            }
          },
          "records": [
            {
              "play": "F8",
              "inning": 1
            }
          ],
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/357643ba-18ab-40bc-a1cd-5fce7e0725fa.png",
          "name": "BLAžKA Ondřej",
          "position": 8,
          "teamGuid": "26249",
          "batting": true,
          "guid": "266285",
          "seasonStats": {
            "pitching": {},
            "batting": {
              "bb": 25,
              "hbp": 3,
              "h": 35,
              "ba": 0.2755905511811024,
              "ab": 127,
              "hr": 1,
              "pa": 159,
              "obp": 0.39622641509433965
            }
          }
        },
        {
          "batting": true,
          "position": 2,
          "records": [
            {
              "inning": 1,
              "play": "H7"
            }
          ],
          "guid": "266287",
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1,
              "h": 1
            }
          },
          "teamGuid": "26249",
          "seasonStats": {
            "pitching": {},
            "batting": {
              "h": 81,
              "hbp": 2,
              "bb": 22,
              "pa": 201,
              "ba": 0.4602272727272727,
              "obp": 0.5223880597014925,
              "ab": 176,
              "hr": 19
            }
          },
          "name": "ČERVENKA Martin",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/5be21f2c-3aa7-410e-a348-198530491ea4.png"
        },
        {
          "records": [
            {
              "inning": 1,
              "play": "Ks"
            }
          ],
          "position": 9,
          "teamGuid": "26249",
          "name": "PETIT Keibert",
          "guid": "266300",
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1
            }
          },
          "seasonStats": {
            "pitching": {},
            "batting": {
              "bb": 25,
              "hr": 3,
              "ba": 0.30718954248366015,
              "obp": 0.40540540540540543,
              "h": 47,
              "pa": 185,
              "hbp": 3,
              "ab": 153
            }
          },
          "batting": true,
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/098c758f-98f2-45c7-9f41-d90297820c6a.png"
        },
        {
          "teamGuid": "26249",
          "position": 11,
          "seasonStats": {
            "pitching": {},
            "batting": {
              "hr": 8,
              "h": 44,
              "pa": 165,
              "hbp": 4,
              "ab": 150,
              "ba": 0.29333333333333333,
              "bb": 8,
              "obp": 0.3393939393939394
            }
          },
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/c97903b1-734c-42e9-856b-915174a7f9eb.png",
          "gameStats": {
            "batting": {
              "ab": 1
            },
            "pitching": {}
          },
          "records": [
            {
              "inning": 1,
              "play": "FC"
            }
          ],
          "batting": true,
          "guid": "266297",
          "name": "MINAříK Marek"
        },
        {
          "records": [
            {
              "inning": 1,
              "play": "Ks"
            }
          ],
          "seasonStats": {
            "batting": {
              "hr": 1,
              "ab": 130,
              "pa": 149,
              "h": 32,
              "bb": 16,
              "obp": 0.33557046979865773,
              "hbp": 2,
              "ba": 0.24615384615384617
            },
            "pitching": {}
          },
          "teamGuid": "26249",
          "batting": true,
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1
            }
          },
          "name": "SMOLA Filip",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/ba35a0c6-6c2b-461a-99a5-7d9ba6b4e7fa.png",
          "guid": "266302",
          "position": 6
        },
        {
          "seasonStats": {
            "pitching": {},
            "batting": {
              "obp": 0.3402061855670103,
              "hr": 2,
              "pa": 194,
              "bb": 17,
              "ab": 166,
              "ba": 0.25301204819277107,
              "hbp": 7,
              "h": 42
            }
          },
          "teamGuid": "26249",
          "batting": true,
          "records": [],
          "name": "ZELENKA Michal",
          "position": 3,
          "guid": "266306",
          "gameStats": {
            "batting": {},
            "pitching": {}
          },
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/d950f673-9733-4d7e-851a-6fa8265beaa9.png"
        },
        {
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/1df9b1d8-bd36-461e-9cc8-33581a46a6ae.png",
          "seasonStats": {
            "batting": {
              "ba": 0.18421052631578946,
              "pa": 141,
              "bb": 22,
              "ab": 114,
              "h": 21,
              "hr": 0,
              "hbp": 1,
              "obp": 0.3120567375886525
            },
            "pitching": {}
          },
          "guid": "266299",
          "teamGuid": "26249",
          "position": 4,
          "batting": true,
          "gameStats": {
            "pitching": {},
            "batting": {}
          },
          "name": "NEVěřIL David",
          "records": []
        },
        {
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/97ea00e9-e271-47cb-8800-62f4c80dae74.png",
          "seasonStats": {
            "pitching": {},
            "batting": {
              "obp": 0.31746031746031744,
              "pa": 126,
              "hr": 0,
              "bb": 19,
              "ab": 102,
              "ba": 0.18627450980392157,
              "hbp": 2,
              "h": 19
            }
          },
          "batting": true,
          "gameStats": {
            "pitching": {},
            "batting": {}
          },
          "teamGuid": "26249",
          "position": 5,
          "guid": "266293",
          "name": "HLUCHý Viktor",
          "records": []
        },
        {
          "seasonStats": {
            "pitching": {},
            "batting": {
              "ab": 95,
              "pa": 114,
              "ba": 0.21052631578947367,
              "h": 20,
              "obp": 0.3333333333333333,
              "bb": 16,
              "hbp": 2,
              "hr": 0
            }
          },
          "gameStats": {
            "batting": {},
            "pitching": {}
          },
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/65fcc40a-4fee-3f15-3cab-2356d1b1e673.png",
          "batting": true,
          "records": [],
          "position": 7,
          "name": "DRáPELA Šimon",
          "teamGuid": "26249",
          "guid": "266289"
        },
        {
          "name": "VANK Ondřej",
          "teamGuid": "26249",
          "batting": false,
          "position": 1,
          "records": [],
          "gameStats": {
            "pitching": {
              "strikes": 18,
              "pitches": 26,
              "k": 1,
              "ip": "1.2",
              "ra": 2,
              "er": 2,
              "h": 3
            },
            "batting": {}
          },
          "guid": "266304",
          "seasonStats": {
            "pitching": {
              "era": 3.796875,
              "er": 18,
              "ip": 42.2,
              "bb": 30,
              "k": 42
            },
            "batting": {}
          },
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/b3e02d3d-da55-4244-96ce-d52b2cf767e8.png"
        }
      ]
    },
    "second": {
      "seasonStats": {
        "batting": {
          "ba": 0.2777777777777778,
          "bb": 17,
          "h": 40,
          "ab": 144,
          "obp": 0.35119047619047616,
          "pa": 168,
          "hr": 6,
          "hbp": 2
        },
        "pitching": {}
      },
      "gameStats": {
        "batting": {
          "ab": 1,
          "h": 1
        },
        "pitching": {}
      },
      "teamGuid": "25213",
      "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/ba3b09cd-4d0b-48d7-825f-1e04f49041c7.png",
      "records": [
        {
          "play": "H8",
          "inning": 2
        }
      ],
      "batting": true,
      "name": "KALáBEK Martin",
      "position": 9,
      "guid": "264787"
    },
    "scoringSystem": "wbsc",
    "away": {
      "errors": 1,
      "shortName": "DRA",
      "lineup": [
        {
          "players": [
            {
              "position": 3,
              "guid": "264791",
              "records": [
                {
                  "play": "4-3",
                  "inning": 1
                }
              ],
              "batting": true,
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/095a6487-d6dc-4d9d-8511-8468e2333f81.png",
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "ba": 0.3155080213903743,
                  "obp": 0.3878504672897196,
                  "hbp": 0,
                  "hr": 2,
                  "pa": 214,
                  "bb": 24,
                  "h": 59,
                  "ab": 187
                }
              },
              "name": "MOšTěK Filip",
              "teamGuid": "25213",
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              }
            }
          ]
        },
        {
          "players": [
            {
              "teamGuid": "25213",
              "records": [
                {
                  "play": "H7",
                  "inning": 1
                }
              ],
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "h": 48,
                  "ab": 156,
                  "hbp": 5,
                  "obp": 0.4146341463414634,
                  "bb": 32,
                  "pa": 205,
                  "ba": 0.3076923076923077,
                  "hr": 0
                }
              },
              "position": 4,
              "batting": true,
              "guid": "264783",
              "gameStats": {
                "pitching": {},
                "batting": {
                  "h": 1,
                  "ab": 1
                }
              },
              "name": "HAJTMAR Jakub",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/15f0ccd7-56c9-4e9d-983a-6023fb3fdef9.png"
            }
          ]
        },
        {
          "players": [
            {
              "gameStats": {
                "pitching": {},
                "batting": {
                  "ab": 1
                }
              },
              "position": 2,
              "guid": "290823",
              "records": [
                {
                  "play": "F6",
                  "inning": 1
                }
              ],
              "teamGuid": "25213",
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "hbp": 4,
                  "ba": 0.38524590163934425,
                  "h": 47,
                  "pa": 146,
                  "bb": 17,
                  "hr": 4,
                  "obp": 0.4657534246575342,
                  "ab": 122
                }
              },
              "batting": true,
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/0bebba36-51c0-4c56-8321-cbc13f2bff2a.png",
              "name": "ANGULO Andres"
            }
          ]
        },
        {
          "players": [
            {
              "records": [
                {
                  "inning": 1,
                  "play": "HR"
                }
              ],
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/0d08745d-f451-4d4d-b353-df7d84407906.png",
              "teamGuid": "25213",
              "gameStats": {
                "batting": {
                  "h": 1,
                  "ab": 1
                },
                "pitching": {}
              },
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "obp": 0.46195652173913043,
                  "ab": 150,
                  "h": 52,
                  "hr": 5,
                  "pa": 184,
                  "bb": 22,
                  "ba": 0.3466666666666667,
                  "hbp": 11
                }
              },
              "position": 6,
              "name": "PROKOP Milan",
              "guid": "264794",
              "batting": true
            }
          ]
        },
        {
          "players": [
            {
              "teamGuid": "25213",
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "h": 31,
                  "hr": 0,
                  "pa": 138,
                  "bb": 13,
                  "ab": 118,
                  "ba": 0.2627118644067797,
                  "hbp": 0,
                  "obp": 0.3188405797101449
                }
              },
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              },
              "records": [
                {
                  "inning": 1,
                  "play": "Ks"
                }
              ],
              "batting": true,
              "guid": "264780",
              "name": "DUBOVý Arnošt",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/7ebd6468-ff11-43ee-8c28-c0eb7835435e.png",
              "position": 8
            }
          ]
        },
        {
          "players": [
            {
              "batting": true,
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/ba3b09cd-4d0b-48d7-825f-1e04f49041c7.png",
              "seasonStats": {
                "batting": {
                  "obp": 0.35119047619047616,
                  "pa": 168,
                  "hbp": 2,
                  "h": 40,
                  "bb": 17,
                  "hr": 6,
                  "ba": 0.2777777777777778,
                  "ab": 144
                },
                "pitching": {}
              },
              "teamGuid": "25213",
              "guid": "264787",
              "position": 9,
              "records": [
                {
                  "inning": 2,
                  "play": "H8"
                }
              ],
              "name": "KALáBEK Martin",
              "gameStats": {
                "pitching": {},
                "batting": {
                  "h": 1,
                  "ab": 1
                }
              }
            }
          ]
        },
        {
          "players": [
            {
              "teamGuid": "25213",
              "records": [
                {
                  "play": "L8",
                  "inning": 2
                }
              ],
              "position": 11,
              "name": "ČERVINKA Martin",
              "guid": "264779",
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              },
              "batting": true,
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/fc9db391-b915-4694-9d94-1da039c19a59.png",
              "seasonStats": {
                "batting": {
                  "hbp": 3,
                  "obp": 0.31666666666666665,
                  "h": 24,
                  "ab": 102,
                  "bb": 11,
                  "hr": 1,
                  "pa": 120,
                  "ba": 0.23529411764705882
                },
                "pitching": {}
              }
            }
          ]
        },
        {
          "players": [
            {
              "gameStats": {
                "batting": {
                  "ab": 1
                },
                "pitching": {}
              },
              "teamGuid": "25213",
              "name": "ŠINDELKA Michal",
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/0bbfb70a-695c-48b5-9166-9ec21db2fe1b.png",
              "position": 7,
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "h": 21,
                  "hbp": 1,
                  "ba": 0.2625,
                  "ab": 80,
                  "obp": 0.3548387096774194,
                  "hr": 0,
                  "bb": 11,
                  "pa": 93
                }
              },
              "guid": "264797",
              "batting": true,
              "records": [
                {
                  "play": "5-3",
                  "inning": 2
                }
              ]
            }
          ]
        },
        {
          "players": [
            {
              "seasonStats": {
                "pitching": {},
                "batting": {
                  "bb": 14,
                  "hbp": 2,
                  "ab": 89,
                  "h": 28,
                  "pa": 117,
                  "obp": 0.37606837606837606,
                  "hr": 0,
                  "ba": 0.3146067415730337
                }
              },
              "gameStats": {
                "batting": {},
                "pitching": {}
              },
              "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/511fc1e3-fc46-4549-9850-2f16970362c4.png",
              "name": "WINKLER Jakub",
              "guid": "264808",
              "records": [],
              "teamGuid": "25213",
              "position": 5,
              "batting": true
            }
          ]
        }
      ],
      "runs": 2,
      "fullName": "DRA",
      "pitchers": [
        {
          "guid": "264801",
          "records": [],
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/3ef08f14-239c-4cb6-8c87-99f9b2a0a33f.png",
          "seasonStats": {
            "batting": {},
            "pitching": {
              "era": 3.356756756756757,
              "ip": 61.2,
              "er": 23,
              "bb": 24,
              "k": 40
            }
          },
          "teamGuid": "25213",
          "name": "VAšOUREK Jan",
          "gameStats": {
            "pitching": {
              "ra": 1,
              "strikes": 14,
              "pitches": 18,
              "k": 2,
              "h": 1,
              "ip": "1.0",
              "er": 1
            },
            "batting": {}
          },
          "batting": false,
          "position": 1
        }
      ],
      "roster": [
        {
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/095a6487-d6dc-4d9d-8511-8468e2333f81.png",
          "batting": true,
          "gameStats": {
            "batting": {
              "ab": 1
            },
            "pitching": {}
          },
          "position": 3,
          "teamGuid": "25213",
          "name": "MOšTěK Filip",
          "guid": "264791",
          "seasonStats": {
            "batting": {
              "ba": 0.3155080213903743,
              "hr": 2,
              "h": 59,
              "hbp": 0,
              "obp": 0.3878504672897196,
              "bb": 24,
              "ab": 187,
              "pa": 214
            },
            "pitching": {}
          },
          "records": [
            {
              "inning": 1,
              "play": "4-3"
            }
          ]
        },
        {
          "guid": "264783",
          "records": [
            {
              "inning": 1,
              "play": "H7"
            }
          ],
          "name": "HAJTMAR Jakub",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/15f0ccd7-56c9-4e9d-983a-6023fb3fdef9.png",
          "teamGuid": "25213",
          "seasonStats": {
            "batting": {
              "obp": 0.4146341463414634,
              "ba": 0.3076923076923077,
              "h": 48,
              "hr": 0,
              "hbp": 5,
              "bb": 32,
              "ab": 156,
              "pa": 205
            },
            "pitching": {}
          },
          "position": 4,
          "batting": true,
          "gameStats": {
            "pitching": {},
            "batting": {
              "h": 1,
              "ab": 1
            }
          }
        },
        {
          "guid": "290823",
          "gameStats": {
            "batting": {
              "ab": 1
            },
            "pitching": {}
          },
          "position": 2,
          "teamGuid": "25213",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/0bebba36-51c0-4c56-8321-cbc13f2bff2a.png",
          "name": "ANGULO Andres",
          "batting": true,
          "records": [
            {
              "inning": 1,
              "play": "F6"
            }
          ],
          "seasonStats": {
            "pitching": {},
            "batting": {
              "pa": 146,
              "ba": 0.38524590163934425,
              "h": 47,
              "hbp": 4,
              "obp": 0.4657534246575342,
              "hr": 4,
              "ab": 122,
              "bb": 17
            }
          }
        },
        {
          "batting": true,
          "gameStats": {
            "batting": {
              "ab": 1,
              "h": 1
            },
            "pitching": {}
          },
          "position": 6,
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/0d08745d-f451-4d4d-b353-df7d84407906.png",
          "records": [
            {
              "inning": 1,
              "play": "HR"
            }
          ],
          "teamGuid": "25213",
          "guid": "264794",
          "seasonStats": {
            "batting": {
              "ab": 150,
              "bb": 22,
              "hbp": 11,
              "pa": 184,
              "h": 52,
              "obp": 0.46195652173913043,
              "ba": 0.3466666666666667,
              "hr": 5
            },
            "pitching": {}
          },
          "name": "PROKOP Milan"
        },
        {
          "guid": "264780",
          "seasonStats": {
            "pitching": {},
            "batting": {
              "bb": 13,
              "hr": 0,
              "ab": 118,
              "obp": 0.3188405797101449,
              "hbp": 0,
              "pa": 138,
              "ba": 0.2627118644067797,
              "h": 31
            }
          },
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/7ebd6468-ff11-43ee-8c28-c0eb7835435e.png",
          "records": [
            {
              "inning": 1,
              "play": "Ks"
            }
          ],
          "teamGuid": "25213",
          "position": 8,
          "name": "DUBOVý Arnošt",
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1
            }
          },
          "batting": true
        },
        {
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/ba3b09cd-4d0b-48d7-825f-1e04f49041c7.png",
          "seasonStats": {
            "pitching": {},
            "batting": {
              "h": 40,
              "obp": 0.35119047619047616,
              "bb": 17,
              "pa": 168,
              "ba": 0.2777777777777778,
              "hr": 6,
              "ab": 144,
              "hbp": 2
            }
          },
          "gameStats": {
            "batting": {
              "ab": 1,
              "h": 1
            },
            "pitching": {}
          },
          "name": "KALáBEK Martin",
          "batting": true,
          "position": 9,
          "teamGuid": "25213",
          "records": [
            {
              "play": "H8",
              "inning": 2
            }
          ],
          "guid": "264787"
        },
        {
          "guid": "264779",
          "position": 11,
          "teamGuid": "25213",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/fc9db391-b915-4694-9d94-1da039c19a59.png",
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1
            }
          },
          "records": [
            {
              "play": "L8",
              "inning": 2
            }
          ],
          "seasonStats": {
            "batting": {
              "hbp": 3,
              "bb": 11,
              "obp": 0.31666666666666665,
              "ab": 102,
              "pa": 120,
              "h": 24,
              "hr": 1,
              "ba": 0.23529411764705882
            },
            "pitching": {}
          },
          "name": "ČERVINKA Martin",
          "batting": true
        },
        {
          "seasonStats": {
            "batting": {
              "ab": 80,
              "pa": 93,
              "h": 21,
              "hr": 0,
              "hbp": 1,
              "ba": 0.2625,
              "obp": 0.3548387096774194,
              "bb": 11
            },
            "pitching": {}
          },
          "records": [
            {
              "play": "5-3",
              "inning": 2
            }
          ],
          "name": "ŠINDELKA Michal",
          "teamGuid": "25213",
          "guid": "264797",
          "position": 7,
          "batting": true,
          "gameStats": {
            "pitching": {},
            "batting": {
              "ab": 1
            }
          },
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/0bbfb70a-695c-48b5-9166-9ec21db2fe1b.png"
        },
        {
          "position": 5,
          "batting": true,
          "name": "WINKLER Jakub",
          "seasonStats": {
            "pitching": {},
            "batting": {
              "obp": 0.37606837606837606,
              "bb": 14,
              "pa": 117,
              "ba": 0.3146067415730337,
              "hbp": 2,
              "hr": 0,
              "h": 28,
              "ab": 89
            }
          },
          "teamGuid": "25213",
          "records": [],
          "guid": "264808",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/511fc1e3-fc46-4549-9850-2f16970362c4.png",
          "gameStats": {
            "batting": {},
            "pitching": {}
          }
        },
        {
          "records": [],
          "seasonStats": {
            "batting": {},
            "pitching": {
              "era": 3.356756756756757,
              "k": 40,
              "bb": 24,
              "ip": 61.2,
              "er": 23
            }
          },
          "teamGuid": "25213",
          "guid": "264801",
          "position": 1,
          "gameStats": {
            "batting": {},
            "pitching": {
              "k": 2,
              "ra": 1,
              "strikes": 14,
              "er": 1,
              "h": 1,
              "ip": "1.0",
              "pitches": 18
            }
          },
          "batting": false,
          "name": "VAšOUREK Jan",
          "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/3ef08f14-239c-4cb6-8c87-99f9b2a0a33f.png"
        }
      ],
      "scoreBoard": [
        2
      ],
      "guid": "25213",
      "hits": 3
    },
    "lastUpdate": {
      "seconds": 1692451834,
      "nanoseconds": 289000000
    },
    "finished": false,
    "balls": 1,
    "currentBatter": {
      "seasonStats": {
        "pitching": {},
        "batting": {
          "hr": 0,
          "hbp": 2,
          "h": 28,
          "obp": 0.37606837606837606,
          "ab": 89,
          "ba": 0.3146067415730337,
          "pa": 117,
          "bb": 14
        }
      },
      "records": [],
      "position": 5,
      "name": "WINKLER Jakub",
      "gameStats": {
        "pitching": {},
        "batting": {}
      },
      "guid": "264808",
      "imageSrc": "https://s3-eu-west-1.amazonaws.com/static.wbsc.org/uploads/federations/6/photos/511fc1e3-fc46-4549-9850-2f16970362c4.png",
      "teamGuid": "25213",
      "batting": true
    },
    "inningPart": "T",
    "lastUpdateIndex": 50
  },
  "fullRosters": [
    {
      "batting": true,
      "guid": "266285",
      "name": "Blažka Ondřej",
      "teamGuid": "26249",
      "number": 48
    },
    {
      "batting": true,
      "name": "Červenka Martin",
      "teamGuid": "26249",
      "number": 55,
      "guid": "266287"
    },
    {
      "number": 46,
      "batting": true,
      "name": "Čuhel Lubomír",
      "guid": "266288",
      "teamGuid": "26249"
    },
    {
      "batting": true,
      "number": 19,
      "teamGuid": "26249",
      "guid": "266286",
      "name": "Cyprian Adam"
    },
    {
      "teamGuid": "26249",
      "batting": true,
      "name": "Drápela Šimon",
      "guid": "266289",
      "number": 1
    },
    {
      "batting": true,
      "guid": "266290",
      "teamGuid": "26249",
      "number": 24,
      "name": "Dupal Štěpán"
    },
    {
      "batting": true,
      "name": "Duran Jhonny",
      "number": 72,
      "teamGuid": "26249",
      "guid": "274521"
    },
    {
      "batting": true,
      "number": 18,
      "name": "Gutierrez Adonai",
      "guid": "266291",
      "teamGuid": "26249"
    },
    {
      "batting": true,
      "name": "Hluchý Nikolas",
      "teamGuid": "26249",
      "guid": "266292",
      "number": 70
    },
    {
      "number": 50,
      "guid": "266293",
      "teamGuid": "26249",
      "batting": true,
      "name": "Hluchý Viktor"
    },
    {
      "teamGuid": "26249",
      "batting": true,
      "guid": "266294",
      "name": "Kalčev Tadeáš",
      "number": 16
    },
    {
      "number": 27,
      "guid": "266295",
      "batting": true,
      "name": "Lukavský Kryštof",
      "teamGuid": "26249"
    },
    {
      "guid": "266296",
      "name": "Marani Dominik",
      "teamGuid": "26249",
      "batting": true,
      "number": 31
    },
    {
      "guid": "266297",
      "number": 13,
      "teamGuid": "26249",
      "batting": true,
      "name": "Minařík Marek"
    },
    {
      "guid": "266298",
      "number": 5,
      "teamGuid": "26249",
      "name": "Nepomucký Aleš",
      "batting": true
    },
    {
      "number": 66,
      "batting": true,
      "teamGuid": "26249",
      "name": "Nevěřil David",
      "guid": "266299"
    },
    {
      "guid": "266300",
      "batting": true,
      "number": 17,
      "name": "Petit Keibert",
      "teamGuid": "26249"
    },
    {
      "batting": true,
      "name": "Pláteník Matěj",
      "number": 37,
      "teamGuid": "26249",
      "guid": "266301"
    },
    {
      "teamGuid": "26249",
      "batting": true,
      "number": 2,
      "name": "Smola Filip",
      "guid": "266302"
    },
    {
      "number": 11,
      "batting": true,
      "name": "Vank Ondřej",
      "guid": "266304",
      "teamGuid": "26249"
    },
    {
      "batting": true,
      "name": "Zelenka Martin",
      "teamGuid": "26249",
      "guid": "266305",
      "number": 38
    },
    {
      "number": 30,
      "batting": true,
      "name": "Zelenka Michal",
      "guid": "266306",
      "teamGuid": "26249"
    },
    {
      "batting": true,
      "guid": "266307",
      "teamGuid": "26249",
      "name": "Zhao Aleš",
      "number": 10
    },
    {
      "teamGuid": "25213",
      "guid": "290823",
      "batting": true,
      "name": "Angulo Andres",
      "number": 7
    },
    {
      "teamGuid": "25213",
      "guid": "259619",
      "batting": true,
      "name": "Budský Pavel",
      "number": 24
    },
    {
      "name": "Čapka Filip",
      "number": 14,
      "batting": true,
      "guid": "264777",
      "teamGuid": "25213"
    },
    {
      "name": "Červinka Martin",
      "guid": "264779",
      "teamGuid": "25213",
      "batting": true,
      "number": 10
    },
    {
      "batting": true,
      "name": "Chadim Tomáš",
      "guid": "264776",
      "number": 1,
      "teamGuid": "25213"
    },
    {
      "number": 27,
      "batting": true,
      "guid": "285437",
      "name": "Chroust Přemek",
      "teamGuid": "25213"
    },
    {
      "guid": "264780",
      "teamGuid": "25213",
      "name": "Dubový Arnošt",
      "number": 9,
      "batting": true
    },
    {
      "guid": "264782",
      "batting": true,
      "teamGuid": "25213",
      "number": 12,
      "name": "Furko Ondřej"
    },
    {
      "guid": "264783",
      "name": "Hajtmar Jakub",
      "batting": true,
      "number": 2,
      "teamGuid": "25213"
    },
    {
      "name": "Hrbek Tomáš",
      "number": 84,
      "batting": true,
      "guid": "264784",
      "teamGuid": "25213"
    },
    {
      "name": "Hřib Martin",
      "number": 6,
      "teamGuid": "25213",
      "batting": true,
      "guid": "264785"
    },
    {
      "guid": "288730",
      "name": "Hurtado Jhenderson",
      "batting": true,
      "teamGuid": "25213",
      "number": 28
    },
    {
      "number": 58,
      "name": "Jaime Mojica Juan Jose",
      "batting": true,
      "guid": "285438",
      "teamGuid": "25213"
    },
    {
      "name": "Kalábek Martin",
      "number": 8,
      "guid": "264787",
      "batting": true,
      "teamGuid": "25213"
    },
    {
      "name": "Klacl Šimon",
      "teamGuid": "25213",
      "guid": "319574",
      "batting": true,
      "number": 98
    },
    {
      "batting": true,
      "guid": "313042",
      "number": 0,
      "name": "Koukal Ondřej",
      "teamGuid": "25213"
    },
    {
      "guid": "264789",
      "number": 18,
      "name": "Krejčí Jonáš",
      "teamGuid": "25213",
      "batting": true
    },
    {
      "name": "Major Vincent",
      "teamGuid": "25213",
      "batting": true,
      "number": 0,
      "guid": "313043"
    },
    {
      "name": "Mendoza Beicker",
      "teamGuid": "25213",
      "guid": "267307",
      "batting": true,
      "number": 33
    },
    {
      "name": "Menšík Lukáš",
      "guid": "264790",
      "teamGuid": "25213",
      "number": 14,
      "batting": true
    },
    {
      "guid": "258869",
      "teamGuid": "25213",
      "batting": true,
      "number": 43,
      "name": "Mergans David"
    },
    {
      "batting": true,
      "teamGuid": "25213",
      "guid": "267764",
      "name": "Morao Gabriel",
      "number": 26
    },
    {
      "batting": true,
      "teamGuid": "25213",
      "number": 31,
      "name": "Moštěk Filip",
      "guid": "264791"
    },
    {
      "teamGuid": "25213",
      "batting": true,
      "number": 16,
      "name": "Nebenführ Jan",
      "guid": "264792"
    },
    {
      "number": 23,
      "name": "Pernička Martin",
      "teamGuid": "25213",
      "guid": "264793",
      "batting": true
    },
    {
      "number": 56,
      "name": "Prokop Milan",
      "batting": true,
      "guid": "264794",
      "teamGuid": "25213"
    },
    {
      "guid": "264795",
      "teamGuid": "25213",
      "number": 86,
      "name": "Prudil Adam",
      "batting": true
    },
    {
      "guid": "267765",
      "teamGuid": "25213",
      "name": "Sanchez Kleyder",
      "batting": true,
      "number": 15
    },
    {
      "teamGuid": "25213",
      "name": "Šindelka Michal",
      "guid": "264797",
      "batting": true,
      "number": 11
    },
    {
      "teamGuid": "25213",
      "number": 52,
      "guid": "288731",
      "batting": true,
      "name": "Solarte Jackson"
    },
    {
      "number": 3,
      "batting": true,
      "teamGuid": "25213",
      "name": "Tauš Václav",
      "guid": "264798"
    },
    {
      "teamGuid": "25213",
      "name": "Urbánek Tomáš",
      "guid": "264799",
      "batting": true,
      "number": 39
    },
    {
      "batting": true,
      "name": "Vašourek Jan",
      "number": 42,
      "guid": "264801",
      "teamGuid": "25213"
    },
    {
      "batting": true,
      "name": "Večerka Viktor",
      "guid": "264802",
      "number": 40,
      "teamGuid": "25213"
    },
    {
      "batting": true,
      "teamGuid": "25213",
      "number": 95,
      "name": "Ventruba Vojtěch",
      "guid": "264807"
    },
    {
      "name": "Winkler Jakub",
      "guid": "264808",
      "batting": true,
      "teamGuid": "25213",
      "number": 25
    },
    {
      "batting": true,
      "guid": "267766",
      "teamGuid": "25213",
      "number": 17,
      "name": "Winkler David"
    }
  ],
  "lowerThird": {
    "info": "Lead Commentator & Color Commentator",
    "name": "IN THE BOOTH",
    "teamGuid": null,
    "guid": null,
    "batting": false
  }
}
